
import { useStore } from "vuex";
import { defineComponent } from "vue";
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";

export default defineComponent({
    name: "NavMenuRight",
    components: {
      GenericPanel,
      GenericButton,
    },
    setup() {
        const store = useStore();
        return {
            state: store.state,
            ui: store.state.ui,
        };
    },
});
